import React from "react";

interface ComingSoonProps {
  section: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ section }) => (
  <div className="flex flex-col items-center justify-center h-64 border-2 border-dashed border-gray-200 rounded-2xl">
    <p className="text-sm font-medium text-gray-400">{section}</p>
    <p className="text-xs text-gray-300 mt-1">Coming soon</p>
  </div>
);
